import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

import './InputWrapper.scss';

	// Props:
	//		info: The details about the input, this appears in a box I think.
	//		description: Description of the input, this appears between the label and the input
	//		errors:	An object.  If it contains the ID property of this item, this input will be marked as having errored and show the message
	//		id: The ID of this input - it should be unique to this form
	//		label: the label/heading
	//		children: The input


class InputWrapper extends Component {
	constructor(props) {
		super(props);
		this.state= {
			info_open: false
		}
		this.handleInfoClick = this.handleInfoClick.bind(this);
		this.hideInfo = this.hideInfo.bind(this);
	}
	
	componentDidMount() {
	}
	
	componentWillUnmount() {
		window.removeEventListener('click', this.hideInfo);
	}

	
	hideInfo() {
		this.setState({info_open: false});
			console.log("removing event listener 3");
		window.removeEventListener('click', this.hideInfo);
	}
	
	handleInfoClick(event) {
		event.preventDefault();
		event.stopPropagation();
		const next = !this.state.info_open;
		if (next) {
			window.addEventListener('click', this.hideInfo);
		} else {
			window.removeEventListener('click', this.hideInfo);
		}
		this.setState({info_open: next});
	}

	info() {
		if (this.state.info_open && this.props.hasOwnProperty('info') && this.props.info.length > 0) {
			return <div className="info">
				{this.props.info}
			</div>;
		}
		return '';
	}
	
	info_button() {
		if (this.props.hasOwnProperty('info') && this.props.info.length > 0) {
			return <button className="infoButton" onClick={this.handleInfoClick}><FontAwesomeIcon icon={faInfo} /></button>
		}
		return '';
	}

	description() {
		if (this.props.hasOwnProperty('description') && this.props.description.length > 0) {
			return  <p className="description">{this.props.description}</p>;
		}
		return '';
	}
	
	error() {
		if (this.props.hasOwnProperty('errors') && typeof this.props.errors === 'object' && this.props.errors !== null && this.props.errors.hasOwnProperty(this.props.id)) {
			return <div className="errorMessage">Error: {this.props.errors[this.props.id]}</div>;
		}
		return '';
	}
	
	
	label() {
		if (this.props.hasOwnProperty('label') && this.props.label.length > 0) {
			if (this.props.hasOwnProperty('id')) {
				return <label htmlFor={this.props.id}>{this.props.label}</label>;
			} else {
				return <label>{this.props.label}</label>;
			}
		}
		return '';
	}

	render() {
		const error = this.error();
		const show_error = (error !== '');
		return (
			<div className={"InputWrapper " + (this.props.className || '') + (show_error ? ' error' : '')}>
				{this.label()}
				{this.description()}
				<div className={"inner"}>
					{this.props.children}
					{error}
				</div>{this.info_button()}
				{this.info()}
			</div>
		);
	}
}

export default InputWrapper;
